import { TESTIDS } from "@/constants/testIds";
import { MessageCircle, FileText, PackageCheck } from "lucide-react";

const WA = "https://wa.me/56936400479?text=Hola%2C%20quiero%20cotizar%20una%20base%20de%20datos";

const steps = [
  {
    n: "01",
    icon: MessageCircle,
    title: "Nos escribes por WhatsApp",
    desc: "Cuéntanos qué tipo de contactos necesitas: rubro, región, tamaño, filtros.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Te enviamos cotización",
    desc: "Respondemos rápido con una propuesta clara, ejemplos y precio final.",
  },
  {
    n: "03",
    icon: PackageCheck,
    title: "Recibes tu base lista",
    desc: "En menos de 24h para bases estándar. 1 a 3 días para pedidos personalizados.",
  },
];

export default function Process() {
  return (
    <section
      data-testid={TESTIDS.processSection}
      className="relative py-24 lg:py-32 border-t border-[rgba(0,240,255,0.08)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="mb-14">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff] mb-4">
            / 04 — Proceso
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight max-w-2xl">
            Tres pasos. <span className="italic font-light text-[#00f0ff]">Cero</span>{" "}
            fricción.
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-5 relative">
          {/* Connecting line */}
          <div
            className="hidden lg:block absolute top-12 left-[16.6%] right-[16.6%] h-px"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(0,240,255,0.4) 20%, rgba(0,240,255,0.4) 80%, transparent)",
            }}
          />

          {steps.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.n} className="relative">
                <div className="bg-[#040812] border border-[rgba(0,240,255,0.2)] rounded-2xl p-7 h-full relative overflow-hidden group hover:border-[rgba(0,240,255,0.5)] transition-all">
                  <div className="absolute top-5 right-5 font-display font-black text-7xl text-[rgba(0,240,255,0.08)] leading-none">
                    {s.n}
                  </div>
                  <div className="relative">
                    <div className="w-14 h-14 rounded-2xl bg-[rgba(0,240,255,0.08)] border border-[rgba(0,240,255,0.3)] flex items-center justify-center mb-6 group-hover:bg-[#00f0ff] transition-colors">
                      <Icon className="text-[#00f0ff] group-hover:text-[#040812] transition-colors" size={22} />
                    </div>
                    <h3 className="font-display font-bold text-white text-xl mb-3">
                      {s.title}
                    </h3>
                    <p className="text-[14px] text-[#94a3b8] leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center gap-5 p-6 rounded-2xl bg-[rgba(0,240,255,0.04)] border border-[rgba(0,240,255,0.15)]">
          <div className="flex-1">
            <h3 className="font-display font-bold text-white text-xl mb-1">
              🧠 ¿No sabes qué base necesitas?
            </h3>
            <p className="text-[#94a3b8] text-[14px]">
              Te ayudamos gratis a definirla. Sin compromiso.
            </p>
          </div>
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold px-6 py-3 rounded-full transition-all shadow-[0_8px_24px_-8px_rgba(37,211,102,0.5)]"
          >
            <MessageCircle size={16} />
            Escríbenos
          </a>
        </div>
      </div>
    </section>
  );
}
